import { loincCoding } from '#src/models/loinc.ts'
import {
  GAD7_WORRY_CONTROL_ANSWERS,
  PHQ_DIFFICULTY_ANSWERS,
  PHQ_FREQUENCY_ANSWERS,
} from '#src/terminology/instruments/instrumentTerminology.ts'
import {
  PHQ_COPYRIGHT,
  PHQ_DIFFICULTY_LABEL,
} from '#src/terminology/instruments/phq9.ts'
import {
  scoreBand,
  scoredItem,
  totalScore,
} from '#src/terminology/instruments/templateParts.ts'
import type {
  InstrumentSection,
  InstrumentTemplate,
} from '#src/terminology/instruments/types.ts'

const SECTIONS: InstrumentSection[] = [
  {
    id: 'items',
    items: [
      scoredItem(
        loincCoding('69725-0', 'Feeling nervous, anxious or on edge'),
        PHQ_FREQUENCY_ANSWERS
      ),
      scoredItem(
        loincCoding(
          '68509-9',
          'Over the past 2 weeks have you not been able to stop or control worrying'
        ),
        GAD7_WORRY_CONTROL_ANSWERS
      ),
      ...[
        ['69733-4', 'Worrying too much about different things'],
        ['69734-2', 'Trouble relaxing'],
        ['69735-9', 'Being so restless that it is hard to sit still'],
        ['69689-8', 'Becoming easily annoyed or irritable.'],
        ['69736-7', 'Feeling afraid as if something awful might happen'],
      ].map(([code, label]) =>
        scoredItem(loincCoding(code, label), PHQ_FREQUENCY_ANSWERS)
      ),
      scoredItem(
        loincCoding('69722-7', PHQ_DIFFICULTY_LABEL),
        PHQ_DIFFICULTY_ANSWERS,
        { scaleType: 'Nom', required: false, scored: false }
      ),
    ],
  },
]

export const GAD7_TEMPLATE: InstrumentTemplate = {
  id: 'gad-7',
  version: '1',
  panel: loincCoding('69737-5', 'Generalized anxiety disorder 7 item (GAD-7)'),
  title: 'Generalized anxiety disorder 7 item (GAD-7)',
  copyright: PHQ_COPYRIGHT,
  reference: 'https://adaa.org/sites/default/files/GAD-7_Anxiety-updated_0.pdf',
  sections: SECTIONS,
  total: totalScore({
    templateId: 'gad-7',
    coding: loincCoding(
      '70274-6',
      'Generalized anxiety disorder 7 item total score'
    ),
    sections: SECTIONS,
    completeness: { requireAll: true },
    bands: [
      scoreBand(
        { min: 0, max: 4 },
        'gad-7-minimal',
        'Minimal Anxiety',
        'green'
      ),
      scoreBand({ min: 5, max: 9 }, 'gad-7-mild', 'Mild Anxiety', 'yellow'),
      scoreBand(
        { min: 10, max: 14 },
        'gad-7-moderate',
        'Moderate Anxiety',
        'orange'
      ),
      scoreBand({ min: 15 }, 'gad-7-severe', 'Severe Anxiety', 'red'),
    ],
  }),
}
